<ng-container [ngSwitch]="filterGroup.presentation">
    <ng-container *ngSwitchCase="'colors'">
        <div [id]="(filter | gridFilterIdSetter : filterGroup) + '-wrapper'" [attr.role]="'text'" class="colors">
            <span class="filter-item-img-color">
                <img [attr.aria-hidden]="'true'" [src]="getAsset(filter)" [alt]="filter.name" loading="lazy" />
                <hr *ngIf="filterGroup.presentation === 'colors'" [class.selected]="filter.selected" />
            </span>
            <span class="filter-item-infos filter-item-infos-colors">
                <span>{{ filter.name }}</span>
                <span [attr.aria-hidden]="'true'"> ({{ filter.total }}) </span>
                <ng-container *ngIf="!filter.facetIsCrawlable">
                    <span hSrOnlyNoSnippet>
                        <span>, {{ filter.total }} </span>
                        <div *ngIf="filter.total > 1; else singularTemplate">
                            <span i18n="@@hermes.accessibility.items">items</span>
                        </div>
                        <ng-template #singularTemplate>
                            <span i18n="@@hermes.accessibility.item">item</span>
                        </ng-template>
                    </span>
                </ng-container>
            </span>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'grid'">
        <span [id]="(filter | gridFilterIdSetter : filterGroup) + '-wrapper'" [attr.role]="'text'">
            <span class="filter-name">
                {{ filter.name }}
            </span>
        </span>
    </ng-container>

    <ng-container *ngSwitchDefault>
        <span class="filter-item-wrapper" [attr.role]="'text'">
            <span class="filter-item-svg" [class.selected]="filter.selected" [id]="filterId + '-svg'">
                <h-svg-icon *ngIf="filter.selected" [name]="'check'" class="filter-item-svg-container"> </h-svg-icon>
            </span>
            <span class="filter-item-infos">
                <span> {{ filter.name }}</span>
                <span [attr.aria-hidden]="'true'"> ({{ filter.total }}) </span>
                <ng-container *ngIf="!filter.facetIsCrawlable">
                    <span hSrOnlyNoSnippet>
                        <span>, {{ filter.total }} </span>
                        <div *ngIf="filter.total > 1; else singularTemplate">
                            <span i18n="@@hermes.accessibility.items">items</span>
                        </div>
                        <ng-template #singularTemplate>
                            <span i18n="@@hermes.accessibility.item">item</span>
                        </ng-template>
                    </span>
                </ng-container>
            </span>
        </span>
    </ng-container>
</ng-container>
